import { Maestro_Aliados } from './Maestro_Aliados';
import { Maestro_AliadosCanales } from './Maestro_AliadosCanales';
import { Maestro_Notificaciones } from './Maestro_Notificaciones';
import { Maestro_AliadosPorcentajeBeneficiarios } from './Maestro_AliadosPorcentajeBeneficiarios';
import { Maestro_Parametros } from './Maestro_Parametros';

export class Maestro_Aliados_Actualizacion {
    principal: Maestro_Aliados;
    listaCanales: Maestro_AliadosCanales[];
    listaCanalesEliminar: Maestro_AliadosCanales[];
    listaNotificaciones: Maestro_Notificaciones[];
    listaNotificacionesEliminar: Maestro_Notificaciones[];
    listaPorcentajesBeneficiarios: Maestro_AliadosPorcentajeBeneficiarios[];
    listaPorcentajesBeneficiariosEliminar: Maestro_AliadosPorcentajeBeneficiarios[];
    listaParametros: Maestro_Parametros[];
}
